/**
 * Turkish-aware, diacritic-insensitive lowercase.
 *
 * - Turkish characters ı/ş/ğ/ü/ö/ç (and their uppercase forms İ, Ş, Ğ, Ü, Ö, Ç)
 *   are folded to ASCII (i, s, g, u, o, c) so that "yagmurluk" matches "Yağmurluk"
 *   and "sisme" matches "Şişme".
 * - Everything else is lowercased with the Turkish locale to keep the
 *   dotted/dotless-i pair intact for exact matches too.
 *
 * Use this everywhere a user types a search term into an autocomplete/filter.
 */
export function trFold(s) {
  return String(s || "")
    .toLocaleLowerCase("tr")
    .replace(/ı/g, "i")
    .replace(/ş/g, "s")
    .replace(/ğ/g, "g")
    .replace(/ü/g, "u")
    .replace(/ö/g, "o")
    .replace(/ç/g, "c");
}

/**
 * Multi-word, case-insensitive, Turkish-aware AND search.
 *
 * The query is split on whitespace and every non-empty token must be a
 * substring of at least one of the provided haystack fields. Word order
 * does not matter and partial matches (contains) are accepted.
 *
 * Example:
 *   matchesAll("lac mont", ["LACİVERT SOFTSHELL REFLEKTÖRLÜ İŞ MONTU"])
 *   → true  (both "lac" and "mont" appear)
 *
 * @param {string} query           User-typed search text.
 * @param {(string|null|undefined)[]} fields  Fields to search across
 *                                            (name + code + description, etc.)
 * @returns {boolean}
 */
export function matchesAll(query, fields) {
  const q = trFold(query).trim();
  if (!q) return true;
  const tokens = q.split(/\s+/).filter(Boolean);
  const hay = fields
    .filter((f) => f != null && f !== "")
    .map((f) => trFold(f))
    .join(" \u0000 ");
  return tokens.every((tok) => hay.includes(tok));
}

